import { render, staticRenderFns } from "./CityInfo.vue?vue&type=template&id=e04c441e&scoped=true"
import script from "./CityInfo.vue?vue&type=script&lang=js"
export * from "./CityInfo.vue?vue&type=script&lang=js"
import style0 from "./CityInfo.vue?vue&type=style&index=0&id=e04c441e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04c441e",
  null
  
)

export default component.exports